import banks from '../config/banks';

function formatArray(array) {
  if (array.length === 0) { return ''; }
  if (array.length === 1) { return array[0].toString(); }

  const beginning = array.slice(0, -1).join(', ');
  const last = array.slice(-1);
  return [beginning, last].join(' ou ');
}

const bankAccountLengthMessage = (validatorKey) => {
  const bank = banks[validatorKey];
  if (bank) {
    const lengths = bank.numericAccountLength;
    const validLengths = Array.isArray(lengths) ? lengths : [lengths];
    return `Número da conta deve ter ${formatArray(validLengths)} digitos.`;
  }
  if (validatorKey === '1288' || validatorKey === '3701') {
    const lengths = banks['104'].numericAccountLengthLong;
    const validLengths = Array.isArray(lengths) ? lengths : [lengths];
    return `Número da conta deve ter ${formatArray(validLengths)} digitos.`;
  }
  return 'Esse campo é obrigatório.';
};
export default bankAccountLengthMessage;
